module.exports['basename'] = require('./basename')
module.exports['dirname'] = require('./dirname')
module.exports['file_get_contents'] = require('./file_get_contents')
module.exports['pathinfo'] = require('./pathinfo')
module.exports['realpath'] = require('./realpath')
